import { watch } from 'vue';
import { VXETable } from '../../v-x-e-table';
import XEUtils from 'xe-utils';
import { ItemInfo } from './itemInfo';
import { isEnableConf } from '../../tools/utils';
export function isFormItem(item) {
    return item instanceof ItemInfo;
}
export function createItem($xeform, _vm) {
    return isFormItem(_vm) ? _vm : new ItemInfo($xeform, _vm);
}
export function handleFieldOrItem($xeform, fieldOrItem) {
    if (fieldOrItem) {
        return XEUtils.isString(fieldOrItem) ? $xeform.getItemByField(fieldOrItem) : fieldOrItem;
    }
    return null;
}
export function isHiddenItem($xeform, formItem) {
    var reactData = $xeform.reactData;
    var collapseAll = reactData.collapseAll;
    var folding = formItem.folding, visible = formItem.visible;
    return visible === false || (folding && collapseAll);
}
export function isActivetem($xeform, formItem) {
    var visibleMethod = formItem.visibleMethod, itemRender = formItem.itemRender, visible = formItem.visible, field = formItem.field;
    if (visible === false) {
        return visible;
    }
    var compConf = isEnableConf(itemRender) ? VXETable.renderer.get(itemRender.name) : null;
    if (!visibleMethod && compConf && compConf.itemVisibleMethod) {
        visibleMethod = compConf.itemVisibleMethod;
    }
    if (!visibleMethod) {
        return true;
    }
    var data = $xeform.props.data;
    return visibleMethod({ data: data, field: field, property: field, item: formItem, $form: $xeform, $grid: $xeform.xegrid });
}
export function watchItem(props, formItem) {
    Object.keys(props).forEach(function (name) {
        watch(function () { return props[name]; }, function (value) {
            formItem.update(name, value);
        });
    });
}
export function assemItem($xeform, el, formItem, formGather) {
    var reactData = $xeform.reactData;
    var staticItems = reactData.staticItems;
    var parentElem = el.parentNode;
    var parentItem = formGather ? formGather.formItem : null;
    var parentItems = parentItem ? parentItem.children : staticItems;
    if (parentElem) {
        parentItems.splice(XEUtils.arrayIndexOf(parentElem.children, el), 0, formItem);
        reactData.staticItems = staticItems.slice(0);
    }
}
export function destroyItem($xeform, formItem) {
    var reactData = $xeform.reactData;
    var staticItems = reactData.staticItems;
    var index = XEUtils.findIndexOf(staticItems, function (item) { return item.id === formItem.id; });
    if (index > -1) {
        staticItems.splice(index, 1);
    }
    reactData.staticItems = staticItems.slice(0);
}
